export default {
  transportDeliveryOrder: {
    search: {
      outboundNo: '物流出库单号',
      outboundNoPlaceholder: '请输入物流出库单号',
      allotNo: '调拨单号',
      allotNoPlaceholder: '请输入调拨单号',
      salesLadingNo: '销售提单号',
      salesLadingNoPlaceholder: '请输入销售提单号',
      outboundStatus: '状态',
      outboundStatusPlaceholder: '请选择状态',
      outboundType: '出库类型',
      outboundTypePlaceholder: '请选择出库类型',
      startDate: '开单日期开始日期',
      startDatePlaceholder: '请选择开始日期从',
      endDate: '开单日期结束日期',
      endDatePlaceholder: '请选择开始日期至',
      outboundStorageNo: '仓库',
      outboundStorageNoPlaceholder: '请选择仓库',
      good: '商品',
      goodPlaceholder: '请选择商品',
      departmentName: '部门',
      departmentNamePlaceholder: '请选择部门',
      outboundCreatePerson: '业务员',
      outboundCreatePersonPlaceholder: '请选择业务员',
      nameVoyageLicense: '船名航次',
      nameVoyageLicensePlaceholder: '请输入船名航次',
    },
    table: {
      outboundNo: '物流出库单号',
      salesLadingNo: '销售提单号',
      allotNo: '调拨单号',
      returnAndChangeNo: '退换货单号',
      outboundStatus: '状态',
      outboundType: '出库类型',
      outboundCreateTime: '开单日期',
      validDateTo: '有效期至',
      outboundStorageNo: '仓库',
      productName: '商品描述',
      nameVoyageLicense: '船名航次',
      warehouseReceiptsNo: '仓单号',
      storageSendQuantity: '数量',
      companyName: '公司',
      departmentName: '部门',
      outboundCreateDate: '制单日期',
      outboundCreatePerson: '制单人',
      outboundBusinessPersonName: '业务员',
    },
    form: {
      order: '物流出库单',
      info: '基本信息',
      fee: '出库费用',
      goodInfo: '商品信息',
      transportInfo: '运输信息',
      outboundNo: '物流出库单号',
      outboundNoPlaceholder: '系统自动生成',
      outboundCreatePerson: '制单人',
      outboundStatus: '状态',
      companyName: '公司',
      departmentName: '部门',
      outboundDepartment: '物流出库部门',
      storageContactEmail: '仓库邮箱地址',
      writeStorageContactEmail: '请输入仓库邮箱地址',
      outboundCreateDate: '制单日期',
      outboundPrintTime: '出库提单打印',
      salesLadingNo: '销售提单号',
      salesLadingNoPlaceholder: '请输入调拨单号',
      allotNo: '调拨单号',
      allotNoPlaceholder: '请输入调拨单号',
      returnAndChangeNo: '退换货单号',
      returnAndChangeNoPlaceholder: '请输入退换货单号',
      deliveryMethod: '交货方式',
      deliveryMethodPlaceholder: '请选择交货方式',
      outboundCreateTime: '开单日期',
      outboundCreateTimePlaceholder: '请选择开单日期',
      validDateTo: '有效期至',
      validDateToPlaceholder: '请选择有效期至',
      contactPerson: '联系人',
      contactPersonPlaceholder: '请选择联系人',
      outboundBusinessPerson: '业务员',
      outboundBusinessPersonPlaceholder: '请选择业务员',
      sendEmailPlaceholder: '请输入电邮地址',
      contactPhone: '联系方式',
      contactPhonePlaceholder: '请输入联系方式',
      outboundStorageNo: '出库仓库',
      outboundStorageNoPlaceholder: '请选择出库仓库',
      storageContactPhone: '仓库联系方式',
      storageContactPhonePlaceholder: '请输入仓库联系方式',
      outboundType: '出库类型',
      outboundTypePlaceholder: '请选择出库类型',
      customerNo: '收货方名称',
      customerNoPlaceholder: '请选择收货方',
      deliveryNote: '发货备注',
      deliveryNotePlaceholder: '请输入发货备注',
      checkbox1: '出库费物产月结',
      checkbox2: '出库费司机支付',
      checkbox3: '高温费物产月结',
      checkbox4: '补单，出库费物产月结',
      checkbox5: '补单，出库费司机支付',
      isIncludeOutboundExpense: '是否含出库费',
      fisIncludeOutboundExpensePlaceholder: '请选择',
      isSettled: '结算标识',
      printHistory: '打印历史',
      outboundExpense: {
        expenseType: '费用类型',
        expenseTypePlaceholder: '请选择费用类型',
        expenseRate: '费率',
        expenseRatePlaceholder: '请输入费率',
        outboundQuantity: '数量',
        outboundQuantityPlaceholder: '请输入数量',
        outboundExpense: '费用',
        outboundExpensePlaceholder: '请输入费用',
      },
      good: {
        productNo: '商品编码',
        productName: '商品描述',
        productUnit: '单位',
        businessInboundBatchNo: '物流批次',
        businessInboundBatchNoPlaceholder: '请选择',
        businessOrder: '业务指令',
        businessOrderQuantity: '业务指令数量',
        businessOrderPackage: '业务指令件数',
        storageShouldSend: '仓库应发',
        storageShouldSendQuantity: '仓库应发数量',
        storageShouldSendQuantityPlaceholder: '请输入仓库应发数量',
        storageShouldSendPackage: '仓库应发件数',
        storageShouldSendPackagePlaceholder: '请输入仓库应发件数',
        storageSend: '仓库实发',
        storageSendQuantity: '仓库实发数量',
        storageSendQuantityPlaceholder: '请输入仓库实发数量',
        storageSendPackage: '仓库实发件数',
        storageSendPackagePlaceholder: '请输入仓库实发数量',
        nameVoyageLicense: '船名航次',
        nameVoyageLicensePlaceholder: '请输入船名航次',
        warehouseReceiptsNo: '仓单号',
        warehouseReceiptsNoPlaceholder: '请输入仓单号',
        mark: '备注',
        markPlaceholder: '请输入备注',
        customerReceiveQuantity: '客户实收数量',
        shipComplete: '是否完全发货',
      },
      shippingMethod: '运输方式',
      shippingMethodPlaceholder: '请选择运输方式',
      transport: {
        nameVoyageLicense: '船名/航次/车牌',
        nameVoyageLicensePlaceholder: '请输入船名/航次/车牌',
        freightInformation: '船名航次',
        freightInformationPlaceholder: '请输入船名航次',
        contactPerson: '联系人',
        contactPersonPlaceholder: '请输入联系人',
        contactPhoneNo: '联系方式',
        contactPhoneNoPlaceholder: '请输入联系方式',
        identityCardNumber: '身份证号',
        identityCardNumberPlaceholder: '请输入身份证号',
      },
    },
    sendFax: {
      ldc: '长途区号',
      fax: '传真号码',
      receiver1: '收件人',
      sendflag: '发送标志',
      title: '消息',
    },
    sendMessage: {
      customerTitle: '发送短信至客户',
      warehouseTitle: '发送短信到仓库',
      sendEmail: '发送邮件',
      outboundBusinessPerson: '业务员',
      companySaveName: '仓库名称',
      outboundBusinessPersonPlaceholder: '请选择业务员',
      customerNo: '客户名称',
      customerNoPlaceholder: '请选择客户',
      contactPhone: '仓库联系号码',
      contactCustomerPhone: '手机号码',
      contactPhonePlaceholder: '请输入手机号',
      content: '消息',
      contentPlaceholder: '请输入消息内容',
      outboundStorageNo: '仓库名称',
      outboundStorageNoPlaceholder: '请选择仓库',
      warehousePhone: '仓库联系号码',
      warehousePhonePlaceholder: '请输入仓库联系号码',
      emailAddress: '电邮地址',
      emailAddressPlaceholder: '请输入电邮地址',
      addressee: '收件人',
      addresseePlaceholder: '请输入收件人',
    },
    btnList: {
      add: '新增',
      del: '删除',
      save: '保存',
      printBill: '打印提货单',
      printLetter: '打印委托书',
      email: '邮件',
      msgToCustomer: '短信通知客户',
      msgToWareHouse: '短信通知仓库',
      message: '短信通知',
      sendFax: '发送传真',
    },
    msg: {
      copyReturn: '拷贝采购退货单',
      copySearchTable: '拷贝销售提单',
      copyInventory: '拷贝库存调拨单',
      selectWareHouse: '请选择仓库',
      selectType: '请选择前序单据',
      storageSendQuantityNum: '仓库应发数量*0.9<=仓库实发数量<=仓库应发数量*1.1',
      remainingOutQuantity: '剩余数量不能小于仓库应发数量',
    },
    copySearchTable: {
      customerName: '客户名称',
      customerNamePlaceholder: '请选择客户',
      startLadingCreateDate: '开单日期起',
      startLadingCreateDatePlaceholder: '请选择开单日期起',
      endLadingCreateDate: '开单日期至',
      endLadingCreateDatePlaceholder: '请选择开单日期至',
      storageName: '仓库',
      storageNamePlaceholder: '请选择仓库',
      ladingBusinessDepartmentName: '部门',
      ladingBusinessDepartmentNamePlaceholder: '请选择部门',
      ladingNo: '提单号',
      ladingNoPlaceholder: '请输入提单号',
      productDesc: '商品描述',
      productDescPlaceholder: '请选择商品',
      suppilerName: '供应商',
      ladingUnit: '提单单位',
      ladingQuantity: '提单数量',
      remainingQuantityIn: '剩余应入数量',
      remainingQuantityOut: '剩余应出数量',
      nameVoyageLicense: '船名/航次/车牌',
      ladingCreatDate: '开单日期',
    },
    //物流批次
    transportList: {
      batchNo: '批次号',
      productNo: '商品编码',
      storageCompanyCode: '公司编码',
      storageDepartmentCode: '部门编码',
      storageNo: '仓库编码',
      storageQuantity: '数量',
    },
    label: {
      theSaved: '已保存',
      executed: '已执行',
      hadWithdrawn: '已撤销',
      haveDeleted: '已删除',
      logisticsAdded: '物流出库单新增',
      yes: '是',
      no: '否',
      draft: '草稿',
      featureNotOpen: '该功能暂未开放',
    },
  },
};
